const getInitialState = () => ({
  panel_drills: false,
  panel_left: false,
  panel_right: false,
  panel_replay: false,

  expandcard_hints: true,
  expandcard_history: true,
})

const getters = {
  panel_drills: state => state.panel_drills,
  panel_left: state => state.panel_left,
  panel_right: state => state.panel_right,
  panel_replay: state => state.panel_replay,

  expandcard_hints: state => state.expandcard_hints,
  expandcard_history: state => state.expandcard_history,

  panel_conditions: (state, getters, rootState, rootGetters) => {
    const multipleTables = rootGetters['tra/alpha/fh_trainer_tables'] > 1
    const mobile = rootGetters.globals_mobile
    // const max1280 = rootGetters.screen_max1280
    const max1540 = rootGetters.screen_max1540
    const max1760 = rootGetters.screen_max1760
    const min2650 = rootGetters.screen_min2650

    if (mobile) {
      return 'mobile'
    }
    if (max1760 && multipleTables && !min2650) {
      // } if ((max1760 && (multipleTables && !min2650)) || max1280) {
      return 'allHalfOpen'
    }
    if (max1540 || (multipleTables && !min2650)) {
      return 'singlePanelOpen'
    }
    return 'default'
  },

  trainer_panels: (state, getters, rootState, rootGetters) => {
    let res = null
    let common = null

    const cc = getters.panel_conditions
    if (cc === 'mobile') {
      common = {
        noTrigger: true,
        focusMode: true,
        toRight: true,
        hasOpener: false,
      }
      res = {
        panel_left: {
          ...common,
          open: state.panel_left,
          toggleFn: bool => {
            state.panel_left = bool
          },
        },
        panel_right: {
          ...common,
          open: state.panel_right,
          toggleFn: bool => {
            state.panel_right = bool
          },
        },
      }
      // console.log('dbg_getter -- trainer_panels', res)
    } else if (cc === 'allHalfOpen') {
      common = {
        focusMode: rootGetters.focus_mode,
        halfFocusMode: !rootGetters.focus_mode,
        hasOpener: !rootGetters.focus_mode,
      }
      res = {
        panel_left: {
          ...common,
        },
        panel_right: {
          ...common,
          noTrigger: state.panel_replay,
          open: common.focusMode ? state.panel_replay : false,
          toRight: true,
        },
      }
      // console.log('multipleTables&max1780 - half-open panel mode', res)
    } else if (cc === 'singlePanelOpen') {
      common = {
        focusMode: rootGetters.focus_mode,
        hasOpener: !rootGetters.focus_mode,
      }
      res = {
        panel_left: {
          ...common,
          open: common.focusMode ? false : state.panel_left,
          toggleFn: bool => {
            state.panel_left = bool
            state.panel_right = false
          },
        },
        panel_right: {
          ...common,
          toRight: true,
          open: common.focusMode ? state.panel_replay : state.panel_right,
          toggleFn: bool => {
            state.panel_right = bool
            state.panel_left = false
          },
        },
      }
      // console.log('dbg_getter -- trainer_panels', res)
    } else {
      common = {
        focusMode: rootGetters.focus_mode,
        hasOpener: !rootGetters.focus_mode,
      }
      res = {
        panel_left: {
          ...common,
          open: undefined,
        },
        panel_right: {
          ...common,
          open: common.focusMode ? state.panel_replay : undefined,
          hidden: false,
          toRight: true,
        },
      }
    }

    // console.log('dbg_getter -- trainer_panels', res)
    return res
  },
  trainer_panel_drills: (state, getters, rootState, rootGetters) => {
    let res = null

    const mobile = rootGetters.globals_mobile

    if (mobile) {
      res = {
        noTrigger: true,
        focusMode: true,
        hasOpener: false,
        toRight: true,
        open: state.panel_drills,
        toggleFn: () => {
          state.panel_drills = false
        },
      }
      // console.log(res)
    } else {
      res = {
        open: true,
        noTrigger: true,
      }
    }

    // console.log(res)
    // console.log('dbg_getter -- trainer_panels')
    return res
  },
}

const actions = {}
const mutations = {
  panels_set(state, { key, value }) {
    state[key] = value
  },
}

export default {
  state: getInitialState(),
  getters,
  actions,
  mutations,
}
